import React, { useState, useEffect } from "react";
import { HmLabel } from "../../ui/Label";
import { CheckboxProps } from '../../../types';

export const Checkbox: React.FC<CheckboxProps> = ({
  label = '',
  variant = 'primary',
  isChecked = false,
  description = '',
  isRequired = { required: false },
  onCheck
}) => {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    onCheck(event.target.name);
  };

  const variants = {
    primary: 'text-primary-700',
    secondary: 'text-secondary-700',
    plain: 'bg-white text-gray-400 hover:text-gray-500',
    secondary_color: 'text-green-300',
  };

  return (
    <fieldset>
      <div className="space-y-5">
        <div className="relative flex items-start">
          <div className="flex h-6 items-center">
            <input
              name={label}
              type="checkbox"
              checked={checked}
              onChange={handleCheckboxChange}
              className={`h-5 w-5 cursor-pointer checked:bg-checked-tick checked:border checked:border-primary-900 focus:ring-primary-900 focus:ring-offset-0 text-primary-800 ${
                variants[variant]
              } ${
                isRequired.required && !checked
                  ? "rounded focus:rounded border-gray-300"
                  : "rounded border-gray-300"
              }`}
              {...isRequired}
            />
          </div>
          <div className="ml-3 text-sm leading-6">
            {label && <HmLabel text={label} fontWeight={500} />}
            {description && <p className="text-gray-500">{description}</p>}
          </div>
        </div>
      </div>
    </fieldset>
  );
};